/* eslint-disable import/prefer-default-export */
import instance from '../Utils/client'

export const getHandlerFromUser = body => instance({
  method: 'get',
  url: `handlers/${body.id}/get_handler`
})
